import AjaxRequest from './AjaxRequest';
import CallbackHandler from './CallbackHandler';

export default class Event {
	constructor() {
		this.output = [];
	}

	async get(url, data = null, func, message) {
		const self = this;
		const callback = new CallbackHandler();
		const api = new AjaxRequest(url, data);

		await api.getRequest().then(function (response) {
			if (response.status == 200) {
				return self.output = callback.handleSuccess(response, 'output');
			} else {
				callback.handleError(
					self.constructor.name,
					func,
					message,
					response
				);

				self.output = 'An error has occured, please try again';
			}
		})
	}

	async post(url, data = null, func, message) {
		const self = this;
		const callback = new CallbackHandler();
		const api = new AjaxRequest(url, data);

		await api.postRequest().then(function (response) {
			if (response.status == 200) {
				return self.output = callback.handleSuccess(response, 'output');
			} else {
				callback.handleError(
					self.constructor.name,
					func,
					message,
					response
				);

				self.output = 'An error has occured, please try again';
			}
		})
    }

	async index() {
        await this.get('app/sidebarLinks', null, 'app/sidebarLinks', 'Could not get sidebar links. Please refresh.');
        return this.output;
	}

}
